import { gql } from "@apollo/client";

export const FETCH_PRODUCT_IMAGES = gql`
  query FETCH_PRODUCT_IMAGES($id: ID!) {
    product(id: $id) {
      id
      useProductLineImagesIfNoImages
      images: computedImages(size: "300x300") {
        id
        url
      }
    }
  }
`;

export const SYNC_PRODUCT_WIS_IMAGES = gql`
  mutation SYNC_PRODUCT_WIS_IMAGES($productId: ID!, $ids: [String]!) {
    syncWisProductImagesFromOneDrive(productId: $productId, ids: $ids) {
      product {
        id
        images: computedImages(size: "300x300") {
          id
          url
        }
      }
    }
  }
`;

export const SAVE_PRODUCT_IMAGE_SETTINGS = gql`
  mutation SAVE_PRODUCT_IMAGE_SETTINGS(
    $id: ID!
    $simpleFields: ProductSimpleFields
  ) {
    saveProduct(id: $id, simpleFields: $simpleFields) {
      product {
        id
        useProductLineImagesIfNoImages
        images: computedImages(size: "300x300") {
          id
          url
        }
      }
    }
  }
`;
